import  React from 'react';
import _ from 'underscore';
import { connect } from 'react-redux';

export class CheckList extends React.Component {

  constructor(props){
      super(props);

      this.state = {};
  }

  componentDidMount() {
    if (Object.keys(this.state).length === 0 && this.props.app && this.props.app.collectedData &&
      this.props.app.collectedData.storedCheckboxes &&
      Object.keys(this.props.app.collectedData.storedCheckboxes).length !== 0) {
      let newState = {}
      let newCheckboxInitValues = JSON.parse(JSON.stringify(this.props.app.collectedData.storedCheckboxes));
      this.props.options.forEach(item => {
        if (newCheckboxInitValues[item.key]) {
          newState[item.text] = newCheckboxInitValues[item.key]
        }
      });
      this.setState(
        newState
      );
    }

    this.props.options.forEach((option) => {
      const equipment = this.props.app?.iotData?.equipment;

      if (option.key === 'isKone' && equipment.isKone) {
        this.onBoxChecked(option);
      }
      if (option.key === 'isAutomaticCarDoor' && equipment.carDoorAutomatic) {
        this.onBoxChecked(option);
      }
      if (option.key === 'isAutomaticLandingDoor' && equipment.landingDoorAutomatic) {
        this.onBoxChecked(option);
      }
    });
  }

  onBoxChecked(option) {

    var newState = Object.assign({}, this.state);
    var newValue = this.state[option.text] ? false : true;
    newState[option.text] = newValue;

    this.setState(newState);
    this.props.onBoxChecked(option.key ? option.key : option.text);
  }

  render() {

    var key = 0;
    const list = this.props.options.map( (option) => {

      var check = this.state[option.text] ? "check" : "";

      return(
        <div className="options" key={key++} onClick={() => this.onBoxChecked(option)}>
          <div className="radio">
            <div className={"fill " + check }></div>
          </div>
          <span className="value" id={option.text}>
            <div className="value-type">
              { option.text }
            </div>
          </span>
        </div>
      );
    });

    return(
      <div id={this.props.id} className="check-list">
        <div className="head">{this.props.title}</div>
        <div className="radio-list-box">
          <div className="list-box">
            {list}
          </div>
        </div>
      </div>
    );
  }

  
}
function mapStateToProps( { app } ) {
  return { app };
  
}
export default connect(mapStateToProps, null)(CheckList);
